import React from 'react';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { ToastContainer } from 'react-toastify';
import { HMSRoomProvider } from '@100mslive/react-sdk';
import moment from 'moment-timezone';

import { UserProvider } from './contexts/UserContext';
import { PortalProvider } from './contexts/PortalContext';
import MainRouter from './components/routers/MainRouter';
import { installToastDedupe } from './lib/toastDedupe';

import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const queryClient = new QueryClient();

// The same error never toasts twice at once (Nic 2026-10-23).
installToastDedupe();

moment.tz.setDefault(moment.tz.guess());

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <UserProvider>
        <PortalProvider>
          <HMSRoomProvider>
            <MainRouter />
            <ToastContainer />
          </HMSRoomProvider>
        </PortalProvider>
      </UserProvider>
    </QueryClientProvider>
  );
}

export default App;
